import { render, staticRenderFns } from "./absorbance.vue?vue&type=template&id=1979c8e8&scoped=true&"
import script from "./absorbance.vue?vue&type=script&lang=js&"
export * from "./absorbance.vue?vue&type=script&lang=js&"
import style0 from "./absorbance.vue?vue&type=style&index=0&id=1979c8e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1979c8e8",
  null
  
)

export default component.exports